module.exports = __webpack_public_path__ + "img/CellCycle-LICA_GSE236681.a0e7c761.png";